const Chatbot = () => (
	<div className="relative background w-full min-h-screen px-0 lg:px-12 flex flex-col">
		<iframe
				src="https://reefersys-api.stec-apps.com/usuario"
			title="Chatbot"
			className="w-full flex-1 border-none"
		/>
	</div>
);

export default Chatbot;
